import type { GenericError, RequestStatus } from '@skynet/data-ws-core';

export interface TradingGroup {
  id: number;
  name: string;
  exchangeID: number;
}

export interface TradingMessageSession {
  session: string;
  ID: string;
}

export interface TradingState {
  error: null | GenericError;
  groupList: null | TradingGroup[];
  groupListStatus: RequestStatus;
  messageStatus: RequestStatus;
  messageLog: JsonWebMessageRender[];
  sessionCreateStatus: RequestStatus;
  sessionDetails: TradingMessageSession | null;
}

export enum BotCommands {
  GroupList = 'GroupList',
  CreateSession = 'CreateSession',
  WebMessage = 'WebMessage',
  CloseSession = 'CloseSession',
}

export interface JsonTradingSuccess {
  groups: TradingGroup[];
}

export interface CreateSessionPayload {
  groupId: string;
}

export interface JsonTradingCreateSessionSuccess {
  session: string;
}

export interface JsonWebMessageData {
  message: string;
  messageID: number;
  session: string;
}

export interface JsonWebMessageRender extends JsonWebMessageData {
  datetime: string;
}

export interface JsonWebMessage extends JsonWebMessageData {
  command: BotCommands.WebMessage;
}

export interface JsonWebMessageRequest extends JsonWebMessage {
  ID: string;
}

export interface WebMessagePayload {
  message: string;
}
